import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../graphql/types.generated';
export type ChargeTypesQueryVariables = GraphQLTypes.Exact<{
  type?: GraphQLTypes.InputMaybe<GraphQLTypes.ChargeTypeEnum>;
  basis?: GraphQLTypes.InputMaybe<GraphQLTypes.ChargeBasisEnum>;
}>;

export type ChargeTypesQueryResult = { __typename?: 'Query' } & {
  chargeTypes: { __typename?: 'ChargeTypeConnection' } & {
    nodes?: GraphQLTypes.Maybe<
      Array<
        GraphQLTypes.Maybe<
          { __typename?: 'ChargeType' } & Pick<
            GraphQLTypes.ChargeType,
            | 'chargeBasis'
            | 'chargeType'
            | 'fortyFiveFtHc'
            | 'fortyFtDv'
            | 'fortyFtHc'
            | 'hazardous'
            | 'id'
            | 'modeOfTransport'
            | 'name'
            | 'overweight'
            | 'reefer'
            | 'twentyFtDv'
            | 'twentyFtHc'
            | 'vatApplicable'
          >
        >
      >
    >;
  };
};

export const ChargeTypesDocument = gql`
  query chargeTypes($type: ChargeTypeEnum, $basis: ChargeBasisEnum) {
    chargeTypes(paginated: false, type: $type, basis: $basis) {
      nodes {
        chargeBasis
        chargeType
        fortyFiveFtHc
        fortyFtDv
        fortyFtHc
        hazardous
        id
        modeOfTransport
        name
        overweight
        reefer
        twentyFtDv
        twentyFtHc
        vatApplicable
      }
    }
  }
`;
